import type { ChaliceStore } from '../types';

export const selectJobSearchAssistPills = (state: ChaliceStore) =>
  state.jobSearchAssist.pills;
export const selectIsJobSearchAssistLoading = (state: ChaliceStore) =>
  state.jobSearchAssist.isLoading;
